import { Injectable } from '@angular/core';
import {InterventionTeamDetailDto} from '../intervention-team-detail.dto';
import {Subject} from 'rxjs';
import {filter} from 'rxjs/operators';

@Injectable()
export class InterventionTeamManagerState {

  private readonly changes = new Subject<StateChange>();
  public readonly changes$ = this.changes.asObservable();

  public readonly onTeamDeleted$ = this.changes$.pipe(isChangeOfType(InterventionTeamManagerActions.DeleteTeam));
  public readonly onTeamUpdated$ = this.changes$.pipe(isChangeOfType(InterventionTeamManagerActions.UpdateTeam));
  public readonly onTeamAdded$ = this.changes$.pipe(isChangeOfType(InterventionTeamManagerActions.AddTeam));
  constructor() { }

  didAddTeam(team: InterventionTeamDetailDto) {
    this.changes.next({ action: InterventionTeamManagerActions.AddTeam, team});
  }

  didDeleteTeam(team: InterventionTeamDetailDto) {
    this.changes.next({ action: InterventionTeamManagerActions.DeleteTeam, team });
  }

  didUpdateTeam(team: InterventionTeamDetailDto) {
    this.changes.next({ action: InterventionTeamManagerActions.UpdateTeam, team });
  }
}

export enum InterventionTeamManagerActions {
  AddTeam,
  DeleteTeam,
  UpdateTeam,
}

interface StateChange {
  action: InterventionTeamManagerActions,
  team: InterventionTeamDetailDto,
}


function isChangeOfType(type: InterventionTeamManagerActions) {
  return filter(({action}: StateChange) => action === type);
}
